const KEY = "30e039fe649a41909c7155539232901";

export default KEY